module.exports = __webpack_public_path__ + "static/media/sql.52b07f71.png";